import { createSelector } from 'reselect';

import { getQuizConfig } from '../app-factory/selectors';

export const getShowcaseQuizzesLimit = createSelector(
    getQuizConfig,
    (quizConfig) => quizConfig.quizzesViewConfig.showcaseQuizzesLimit
);

export const getDefaultCardImageSrcSet = createSelector(
    getQuizConfig,
    (quizConfig) => quizConfig.quizzesViewConfig.defaultQuizCardImage
);

export const getUserCardImageSrcSet = createSelector(
    getQuizConfig,
    (quizConfig) => quizConfig.quizzesViewConfig.userQuizCardImage
);
